import { Box, Flex, MantineColor, type StyleProp } from '@mantine/core'

import ChevronDown from '@/assets/icons/chevron-down.svg'

import styles from './index.module.css'

interface FakeSelectorProps {
  bg?: StyleProp<MantineColor>
  content?: React.ReactNode
  onClick?: () => void
  onMouseEnter?: () => void
}

export default function FakeSelector({ bg, content, onClick, onMouseEnter }: FakeSelectorProps) {
  return (
    <Flex bg={bg} className={styles.fakeSelector} onClick={onClick} onMouseEnter={onMouseEnter}>
      <Box mr={8}>{content}</Box>
      <ChevronDown fill={'var(--content-secondary)'} width={20} height={20} />
    </Flex>
  )
}
